import React, { useState, useRef } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { ROUTES } from '../constants/Constants';
import './Login.css';

const Login = () => {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(email, password);
      if (result.success) {
        // No need to navigate here, AuthContext already redirects to dashboard
      } else {
        setError(result.error || 'Login failed. Please try again.');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="background-shape shape-1"></div>
        <div className="background-shape shape-2"></div>
      </div>
      <Container className="login-container">
        <motion.div
          className="login-card"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="login-content">
            <h1 className="login-title">Log in</h1>
            <div className="divider-row">
              <div className="divider" />
              <span className="divider-text">or</span>
              <div className="divider" />
            </div>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="loginEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder=""
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="username"
                />
              </Form.Group>
              <Form.Group className="mb-1" controlId="loginPassword">
                <Form.Label>Password</Form.Label>
                <div className="password-input-wrapper">
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder=""
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                  <span
                    className="password-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    tabIndex={0}
                    role="button"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </Form.Group>
              <div className="d-flex justify-content-end mb-3">
                <Link to="/forgot-password" className="forgot-link">
                  Forgot password?
                </Link>
              </div>
              {error && (
                <div className="alert alert-danger" style={{ marginBottom: 16 }}>
                  {error}
                </div>
              )}
              <Button
                variant="primary"
                type="submit"
                className="login-main-btn"
                disabled={loading}
              >
                {loading ? 'Signing in...' : 'Log in'}
              </Button>
            </Form>
            <div className="login-links mt-4">
              <div className="text-center mb-2">
                <Link to="/cant-access" className="cant-access-link">
                  Can't Access Your Account?
                </Link>
              </div>
              <div className="text-center">
                Don't have an account?{' '}
                <Link to="/signup" className="signup-link">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </Container>
    </div>
  );
};

export default Login;
